import { createSlice } from '@reduxjs/toolkit'

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {},
  reducers: {}
})

export default dashboardSlice.reducer